import React from 'react';

import { useMediaQuery } from 'ha/helpers/MediaQuery';

import { LoadableNavBarDesktop } from '../containers/NavBarDesktop.lazy';
import { LoadableNavBarMobile } from '../containers/NavBarMobile.lazy';

interface Props {
  hasStickyNav?: boolean;
  showMiddleMenu?: boolean;
  showSearchBar?: boolean;
  searchBarElement?: React.ReactNode;
  advertiserLogo?: string;
  showActions?: boolean;
  showLogo?: boolean;
  showMobileDrawerMenu?: boolean;
  showUkraineFlair?: boolean;
  showDashboardCTA?: boolean;
}

export const NavBar: React.FC<Props> = ({
  hasStickyNav,
  showMiddleMenu,
  showSearchBar,
  searchBarElement,
  advertiserLogo,
  showActions,
  showLogo,
  showMobileDrawerMenu,
  showUkraineFlair = false,
  showDashboardCTA,
}) => {
  const { md } = useMediaQuery();

  return md ? (
    <LoadableNavBarDesktop
      hasStickyNav={hasStickyNav}
      showMiddleMenu={showMiddleMenu}
      showSearchBar={showSearchBar}
      searchBarElement={searchBarElement}
      advertiserLogo={advertiserLogo}
      showActions={showActions}
      showLogo={showLogo}
      showUkraineFlair={showUkraineFlair}
      showDashboardCTA={showDashboardCTA}
    />
  ) : (
    <LoadableNavBarMobile
      showSearchBar={showSearchBar}
      searchBarElement={searchBarElement}
      showMobileDrawerMenu={showMobileDrawerMenu}
      showLogo={showLogo}
      advertiserLogo={advertiserLogo}
      showUkraineFlair={showUkraineFlair}
    />
  );
};
